<template>
  <div class="upload" :style="'height:'+winHeight+'px;'">
    <div class="step_one">
      <van-steps :active="step_active" active-color="#45B9BC">
        <van-step style="color:#45B9BC;">身份验证</van-step>
        <van-step style="color:#45B9BC;">个人信息</van-step>
        <van-step>证件上传</van-step>
      </van-steps>
    </div>

    <div class="idcard_upload">
      <p>身份证上传</p>

      <div class="idcard_zm fl">
        <div class="van-uploader__wrapper">
          <div v-if="positive.length > 0">
            <div class="van-uploader__upload" v-for="(item,index) in positive" :key="index">
              <img :src="item" class="radius" alt @click="previewImage(0,item)" />
              <p
                class="close fs_12"
                @click="deleImg(0,index)"
                style="position: absolute;top: 0;right: .2rem;font-size: 1.25rem !important;color:#45b9bc;"
              >×</p>
            </div>
          </div>

          <div class="van-uploader__upload" v-if="positive.length < 1" @click="selectImg(0)">
            <i class="van-icon van-icon-plus van-uploader__upload-icon">
              <!---->
            </i>
            <span style="font-size: .6rem;padding-top: .2rem;">身份证正面</span>
          </div>
        </div>
      </div>

      <div class="idcard_fm fl">
        <div class="van-uploader__wrapper">
          <div v-if="reverse.length > 0">
            <div class="van-uploader__upload" v-for="(item,index) in reverse" :key="index">
              <img :src="item" class="radius" alt @click="previewImage(1,item)" />
              <p
                class="close fs_12"
                @click="deleImg(1,index)"
                style="position: absolute;top: 0;right: .2rem;font-size: 1.25rem !important;color:#45b9bc;"
              >×</p>
            </div>
          </div>

          <div class="van-uploader__upload" v-if="reverse.length < 1" @click="selectImg(1)">
            <i class="van-icon van-icon-plus van-uploader__upload-icon">
              <!---->
            </i>
            <span style="font-size: .6rem;padding-top: .2rem;">身份证反面</span>
          </div>
        </div>
      </div>
    </div>

    <div class="idcard_upload" style="margin-top:1rem;">
      <p>职业证书</p>

      <div class="certificate">
        <div class="van-uploader__wrapper">
          <div v-if="certificate.length > 0">
            <div class="van-uploader__upload" v-for="(item,index) in certificate" :key="index">
              <img :src="item" class="radius" alt @click="previewImage(2,item)" />
              <p
                class="close fs_12"
                @click="deleImg(2,index)"
                style="position: absolute;top: 0;right: .2rem;font-size: 1.25rem !important;color:#45b9bc;"
              >×</p>
            </div>
          </div>

          <div class="van-uploader__upload" v-if="certificate.length < 1" @click="selectImg(2)">
            <i class="van-icon van-icon-plus van-uploader__upload-icon">
              <!---->
            </i>
            <span style="font-size: .6rem;padding-top: .2rem;">证书照片</span>
          </div>
        </div>
      </div>
    </div>

    <div class="agreement flex_center">
      <van-icon name="passed" color="#45B9BC" />
      <div class="agreement_tip">
        我已阅读并同意
        <span><router-link :to="{path: 'tech_agreement',query:{type:0}}">《技师合作协议》</router-link></span>
      </div>
    </div>

    <div class="btn_box">
      <button class="next_btn" @click="submit()">提交申请</button>
    </div>
  </div>
</template>

<script>
import storage from '@/common/storage'
export default {
  name: "upload",
  components: {},
  data() {
    return {
      step_active: 2,
      winHeight: document.body.clientHeight,
      positive: [],
      reverse: [],
      certificate: [],
      positiveServerId: [],
      reverseServerId: [],
      certificateServerId: []
    };
  },
  created() {

  },
  methods: {
    post() {
      let applyInfo = storage.s_getItem('applyInfo');
      let authenticationInfo = storage.s_getItem('authenticationInfo');

      this.axios({
        url: this.api.member.tech_apply_submit, //提交申请
        data: {
          applyInfo: applyInfo,
          authenticationInfo: authenticationInfo,
          positiveServerId: this.positiveServerId,
          reverseServerId: this.reverseServerId,
          certificateServerId: this.certificateServerId
        }
      }).then(res => {
        if (res.error === 0) {
          storage.s_clear();
          this.$toast({
            message: res.msg,
            type: "success",
            onClose: () => {
              this.$router.push("/center");
            }
          });
        } else {
          this.$toast({
            message: res.error
          });
        }
      });
    },
    submit() {
     // if (this.positive.length == 0 && this.reverse.length == 0 && this.certificate.length == 0) {
        this.post();
      //}
    },
    selectImg(type) {
      var that = this;
      var _type = type;
      this.axios({
        url: this.api.index.share_url,
        data: {
          url: window.location.href.split("#")[0]
        }
      }).then(function(res) {
        var shareMsg = res.jssdkconfig;
        wx.config({
          // debug:true,
          appId: shareMsg.appId,
          timestamp: shareMsg.timestamp,
          nonceStr: shareMsg.nonceStr,
          signature: shareMsg.signature,
          jsApiList: ["chooseImage", "uploadImage", "previewImage"]
        });
        wx.ready(function() {
          wx.chooseImage({
            count: 1, // 默认9
            sizeType: ["original", "compressed"], // 可以指定是原图还是压缩图，默认二者都有
            sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
            success: function(res) {
              res.localIds.forEach(v => {
                // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                if (_type == 0) {
                  that.positive.push(v);
                }
                if (_type == 1) {
                  that.reverse.push(v);
                }
                if (_type == 2) {
                  that.certificate.push(v);
                }
                that.upLoad_img(_type);
              });
            }
          });
        });
      });
    },
    previewImage(type, url) {
      // 图片预览
      var that = this;
      var img;
      if (type == 0) {
        img = that.positive;
      }
      if (type == 1) {
        img = that.reverse;
      }
      if (type == 2) {
        img = that.certificate;
      }

      wx.previewImage({
        current: url, // 当前显示图片的http链接
        urls: img // 需要预览的图片http链接列表
      });
    },
    deleImg(type, i) {
      if (type == 0) {
        this.positive.splice(i, 1);
      }
      if (type == 1) {
        this.reverse.splice(i, 1);
      }
      if (type == 2) {
        this.certificate.splice(i, 1);
      }
    },
    upLoad_img(type) {
      var that = this;
      var count;
      var imgbox = [];
      var _type = type;
      if (_type == 0) {
        count = that.positive.length;
        imgbox = that.positive;
      }
      if (_type == 1) {
        count = that.reverse.length;
        imgbox = that.reverse;
      }
      if (_type == 2) {
        count = that.certificate.length;
        imgbox = that.certificate;
      }

      if (count < 2) {
        function upLoad() {
          // 多图上传
          wx.uploadImage({
            localId: imgbox[0], // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function(res) {
              
              if (_type == 0) {
                that.positiveServerId.push(res.serverId); // 返回图片的服务器端ID
              }
              if (_type == 1) {
                that.reverseServerId.push(res.serverId); // 返回图片的服务器端ID
              }
              if (_type == 2) {
                that.certificateServerId.push(res.serverId); // 返回图片的服务器端ID
              }
              // that.$toast("positive 剩余数量:" + that.positive.length);

              //   if (that.positive.length > 0) {
              //     this.upLoad_img(0);
              //   }
              //   if (that.reverse.length > 0) {
              //     this.upLoad_img(1);
              //   }
              //   if (that.certificate.length > 0) {
              //     this.upLoad_img(2);
              //   }
              //   if (
              //     that.positive.length == 0 &&
              //     that.reverse.length == 0 &&
              //     that.certificate.length == 0
              //   ) {
              //     that.post();
              //   }
              
            }
          });
        }
        upLoad();
      }
    }
  }
};
</script>
<style scoped>
.van-uploader__upload {
  width: 5rem;
  height: 5rem;
}
.van-uploader__upload img {
  width: 100%;
  height: 100%;
}
.van-cell {
  border-bottom: 1px solid #eee;
}
.upload {
  background-color: white;
}
.bz {
  position: absolute;
}
.van-step--horizontal .van-step__circle-container {
  top: 45px !important;
}
.van-step--horizontal .van-step__line {
  top: 45px !important;
}
.btn_box {
  text-align: center;
}
.next_btn {
  color: white;
  background-color: #45b9bc;
  border-radius: 5px;
  padding: 0.4rem 5rem;
  margin-top: 2.5rem;
  font-size: 0.9rem;
}
.van-steps--horizontal {
  padding: 0.75rem 2rem;
}
.tech_box li {
  background-color: white;
  padding: 0.1rem 1.25rem;
}
.van-button--primary {
  background-color: white;
  border: 1px solid #45b9bc;
  border-radius: 5px;
  color: #45b9bc;
}
.van-step--horizontal .van-step__title {
  font-size: 0.7rem;
}
.idcard_upload {
  background-color: white;
  margin: 0.1rem 1.25rem;
  padding-bottom: 1rem;
  font-size: 0.75rem;
  color: #636363;
  border-bottom: 1px solid #eee;
  clear: both;
  overflow: hidden;
}
.idcard_upload p {
  padding-bottom: 1rem;
}
.idcard_fm {
  margin-left: 1rem;
}
.agreement {
  font-size: 0.6rem;
  color: #a4a5a6;
  margin-left: 1.25rem;
  margin-top: 0.45rem;
}
.agreement_tip {
  padding-left: 0.1rem;
}
.agreement_tip span {
  color: #45b9bc;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/upload.vue